"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrigger = exports.useGap = exports.useGrid = void 0;
var ahooks_1 = require("ahooks");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icons_1 = require("@ant-design/icons");
var adhere_ui_configprovider_1 = __importDefault(require("@baifendian/adhere-ui-configprovider"));
var Fixed_1 = require("./Fixed");
var Util_1 = require("./Util");
// import { ResizeObserver } from '@juggle/resize-observer';
/**
 * useGrid
 * @description 是否使用了栅格系统
 * @param {FixedProps} props
 * @return {boolean}
 */
var useGrid = function (props) {
  return (0, react_1.useMemo)(function () {
    return 'span' in props && typeof props.span === 'number' && props.span >= 0 && props.span <= Fixed_1.gridCount;
  }, [props.span]);
};
exports.useGrid = useGrid;
/**
 * useGap
 * @param {number | number[]} gutter
 * @return {boolean}
 */
var useGap = function (gutter) {
  return (0, react_1.useMemo)(function () {
    if (gutter === undefined || gutter === null || gutter === '' || gutter === 0 || typeof gutter === 'function' || typeof gutter === 'object' && !Array.isArray(gutter)) {
      return false;
    }
    if (Array.isArray(gutter)) {
      if (gutter.length === 0) return false;
      if (gutter.length >= 1 && gutter.length <= 2) {
        return !gutter.some(function (g) {
          return g === undefined || g === null || g === '' || typeof g !== 'number';
        });
      }
    }
    return true;
  }, [gutter]);
};
exports.useGap = useGap;
/**
 * useTrigger
 */
var useTrigger = function (_a) {
  var trigger = _a.trigger,
    _b = _a.collapseDirection,
    collapseDirection = _b === void 0 ? 'L' : _b,
    _c = _a.collapsedSize,
    collapsedSize = _c === void 0 ? 80 : _c,
    _d = _a.defaultCollapsible,
    defaultCollapsible = _d === void 0 ? false : _d,
    onCollapse = _a.onCollapse,
    selectorPrefix = _a.selectorPrefix,
    elRef = _a.elRef;
  var media = (0, react_1.useContext)(adhere_ui_configprovider_1.default.Context).media;
  var targetCollapsedSize = (0, react_1.useMemo)(function () {
    return (0, Util_1.getValueWithUnit)(collapsedSize, media);
  }, [collapsedSize]);
  var _e = (0, react_1.useState)(defaultCollapsible),
    collapsible = _e[0],
    setCollapsible = _e[1];
  // 缺省的Trigger元素
  var DefaultTrigger = (0, react_1.useMemo)(function () {
    if (collapseDirection === 'L') {
      if (collapsible) {
        return react_1.default.createElement(icons_1.DoubleRightOutlined, null);
      } else return react_1.default.createElement(icons_1.DoubleLeftOutlined, null);
    } else if (collapseDirection === 'R') {
      if (collapsible) {
        return react_1.default.createElement(icons_1.DoubleLeftOutlined, null);
      } else return react_1.default.createElement(icons_1.DoubleRightOutlined, null);
    } else if (collapseDirection === 'T') {
      if (collapsible) {
        return react_1.default.createElement(icons_1.DoubleRightOutlined, {
          style: {
            transform: 'rotate(90deg)'
          }
        });
      } else return react_1.default.createElement(icons_1.DoubleLeftOutlined, {
        style: {
          transform: 'rotate(90deg)'
        }
      });
    } else if (collapseDirection === 'B') {
      if (collapsible) {
        return react_1.default.createElement(icons_1.DoubleLeftOutlined, {
          style: {
            transform: 'rotate(90deg)'
          }
        });
      } else return react_1.default.createElement(icons_1.DoubleRightOutlined, {
        style: {
          transform: 'rotate(90deg)'
        }
      });
    }
  }, [collapseDirection, collapsible]);
  // 渲染Trigger
  var renderTrigger = (0, react_1.useCallback)(function () {
    if (trigger) {
      var triggerInner = trigger === null || trigger === void 0 ? void 0 : trigger(collapsible, DefaultTrigger);
      if (triggerInner) {
        return react_1.default.createElement("div", {
          className: (0, classnames_1.default)("".concat(selectorPrefix, "-trigger"), "".concat(selectorPrefix, "-trigger-").concat(collapseDirection === null || collapseDirection === void 0 ? void 0 : collapseDirection.toLowerCase())),
          onClick: _onCollapse
        }, triggerInner);
      }
      return null;
    }
    return null;
  }, [trigger, collapseDirection, DefaultTrigger]);
  var collapseStyle = (0, react_1.useMemo)(function () {
    // 关闭
    if (collapsible) {
      if (collapseDirection === 'L') {
        return {
          maxWidth: targetCollapsedSize
        };
      } else if (collapseDirection === 'R') {
        return {
          maxWidth: targetCollapsedSize
        };
      } else if (collapseDirection === 'T') {
        return {
          maxHeight: targetCollapsedSize
        };
      } else if (collapseDirection === 'B') {
        return {
          maxHeight: targetCollapsedSize
        };
      }
      return {};
    }
    // 显示
    if (collapseDirection === 'L') {
      return {
        maxWidth: '100%'
      };
    } else if (collapseDirection === 'R') {
      return {
        maxWidth: '100%'
      };
    } else if (collapseDirection === 'T') {
      return {
        maxHeight: '100%'
      };
    } else if (collapseDirection === 'B') {
      return {
        maxHeight: '100%'
      };
    }
    return {};
  }, [collapseDirection, collapsible, targetCollapsedSize]);
  (0, ahooks_1.useUpdateEffect)(function () {
    setCollapsible(defaultCollapsible);
  }, [defaultCollapsible]);
  /**
   * _onCollapse
   */
  function _onCollapse() {
    setCollapsible(!collapsible);
    onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!collapsible);
  }
  return {
    renderTrigger: renderTrigger,
    collapseStyle: collapseStyle
  };
};
exports.useTrigger = useTrigger;